import axios from "axios";
import AuthService from "../auth/request";

const getCourses = () => {
  return new Promise((resolve, reject) => {
    let url = "/api/v1/User_Course";
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("a_t");
    let user = JSON.parse(localStorage.getItem("user"));
    axios
      .post(url, {
        user_id: user.id,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch(reject);
  });
};

const getExternalAllCourses = (data) => {
  return new Promise((resolve, reject) => {
    AuthService.getAuthToken().then((response) => {
      let url = "/api/v1/getExternalDestacateCourses/" + data.proyect_id;

      if (data.free) {
        url += "?free=1";
      }

      axios
        .get(
          url,
          (axios.defaults.headers.common["Authorization"] =
            "Bearer " + response.access_token)
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch(reject);
    });
  });
};

const getCoursesByKey = (key) => {
  return new Promise((resolve, reject) => {
    AuthService.getAuthToken().then((response) => {
      let url = `/api/v1/getAllCoursesKey?key_code=${key}&proyect_id=${process.env.VUE_APP_PROYECT_ID}`;
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + response.access_token;
      axios
        .get(url)
        .then((response) => {
          resolve(response.data);

        })
        .catch(reject);
    });
  });
};

const getAllCourses = (category_id, proyect_id) => {
  return new Promise((resolve, reject) => {
    AuthService.getAuthToken().then((response) => {
      let url = "/api/v1/getAllCoursesCategories";
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + response.access_token;
      axios
        .post(url, {
          category_id: category_id,
          type_id: "2",
          proyect_id: proyect_id,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch(reject);
    });
  });
};

const getCoursesDetail = (course_id, proyect_id) => {
  return new Promise((resolve, reject) => {
    AuthService.getAuthToken().then((response) => {
      let url = "/api/v1/getExternalCoursesDetail";
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + response.access_token;
      axios
        .post(url, {
          course_id,
          proyect_id: process.env.VUE_APP_PROYECT_ID,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch(reject);
    });
  });
};

export default {
  getCourses,
  getAllCourses,
  getCoursesDetail,
  getExternalAllCourses,
  getCoursesByKey,
};
